/* eslint-disable jsx-a11y/alt-text */
import React from 'react';
import Head from 'next/head';
import Header from '../../organisms/Header';
import Footer from '../../organisms/Footer';
import VejaTambem from '../../molecules/VejamTambemAmpless';
import Styles from './QuemSomos.css';
import Container from '../../atoms/Container';
import TextBanner from '../../organisms/TextBanner';

function QuemSomos() {
  return (
    <>
      <Head>
        <title>Quem Somos | Santander Financiamentos</title>
        <meta
          name="Description"
          content="A Santander Financiamentos é conhecida pela sua solidez, agilidade na aprovação do crédito e automatização de processos."
        />
        <link
          rel="canonical"
          href="https://www.santander.com.br/hotsite/santanderfinanciamentos/quem-somos.html"
        />
        {/* <!-- OPEN GRAPH TAGS FOR FACEBOOK, WHATSAPP AND LINKEDIN --> */}
        <meta property="og:locale" content="pt_BR" />
        <meta property="og:title" content="Quem Somos | Santander Financiamentos" />
        <meta
          property="og:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/quem-somos.html"
        />
        <meta property="og:site_name" content="Santander Financiamentos" />
        <meta
          property="og:description"
          content="A Santander Financiamentos é conhecida pela sua solidez, agilidade na aprovação do crédito e automatização de processos."
        />
        <meta
          property="og:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/static/amp/quemsomos/imgs/ic_greatplacetowork.png"
        />
        <meta property="og:image:alt" content="Great Place To Work" />
        <meta property="og:image:type" content="image/png" />
        <meta property="og:image:width" content="600" />
        <meta property="og:image:height" content="600" />
        <meta property="og:type" content="website" />
        {/* <!-- TWITTER CARDS FOR TWITTER --> */}
        <meta name="twitter:card" content="summary" />
        <meta name="twitter:title" content="Quem Somos | Santander Financiamentos" />
        <meta
          name="twitter:description"
          content="A Santander Financiamentos é conhecida pela sua solidez, agilidade na aprovação do crédito e automatização de processos."
        />
        <meta
          name="twitter:url"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/quem-somos.html"
        />
        <meta
          property="twitter:image"
          content="https://www.santander.com.br/hotsite/santanderfinanciamentos/static/amp/quemsomos/imgs/ic_greatplacetowork.png"
        />
        <meta property="twitter:image:alt" content="Great Place To Work" />
        <meta property="twitter:image:type" content="image/png" />
        <meta property="twitter:image:width" content="600" />
        <meta property="twitter:image:height" content="600" />
      </Head>
      <Header />
      <section id="santander-boleto">
        <TextBanner
          enableDesktopTopMargin
          src="static/amp/quemsomos/banner/banner_quemsomos.webp"
          fallbackSrc="static/amp/quemsomos/banner/banner_quemsomos.webp"
          usesDesktopImage
          desktopSrc="static/amp/quemsomos/banner/banner_quemsomos.webp"
          fallbackDesktopSrc="static/amp/quemsomos/banner/banner_quemsomos.webp"
          altimg="Apertando as mãos sobre uma mesa com café"
        >
          Quem somos
        </TextBanner>
        <Container extraPadding>
          <section className="main">
            <div>
              <p className="title">
                Somos conhecidos e reconhecidos por nossa solidez, agilidade na aprovação do crédito
                e automatização de processos.
              </p>
              <p className="text">
                No Santander, a gente abre um mundo de possibilidades para o seu desenvolvimento e
                carreira. Você quer desenvolver o seu talento, nós temos as oportunidades.
              </p>
              <p className="text">
                Começando pela nossa iniciativa de desenvolvimento de profissionais, passando pelo
                nosso programa de estágio e chegando aos nossos programas internos de mobilidade
                entre áreas e países, as nossas pessoas são constantemente incentivadas e apoiadas a
                serem as protagonistas da sua carreira.
              </p>
              <p className="text">
                Como um dos grupos financeiros de maior sucesso no mundo, o Santander incentiva e
                investe no potencial de seus profissionais e oferece oportunidades para o seu
                desenvolvimento pessoal e profissional.
              </p>
            </div>
          </section>
          <section>
            <p className="title financiamento">Confira nossas linhas de financiamento</p>

            <div className="icons-box">
              <div className="icon">
                <img
                  src="static/amp/quemsomos/icons/ic_vehicle_car.png"
                  layout="fixed"
                  width="27px"
                  height="22px"
                  alt=""
                />
              </div>

              <p className="icon-p">Veículos e motos</p>
            </div>
            <div className="icons-box">
              <div className="icon">
                <img
                  src="static/amp/quemsomos/icons/ic_doctor.png"
                  layout="fixed"
                  width="27px"
                  height="22px"
                  alt=""
                />
              </div>
              <p className="icon-p">Equipamento médico-hospitalares e equipamentos odontológicos</p>
            </div>
            <div className="icons-box">
              <div className="icon">
                <img
                  src="static/amp/quemsomos/icons/ic_reform.png"
                  layout="fixed"
                  width="27px"
                  height="22px"
                  alt=""
                />
              </div>
              <p className="icon-p">Móveis e materiais para construção</p>
            </div>
            <div className="icons-box">
              <div className="icon">
                <img
                  src="static/amp/quemsomos/icons/ic_travel.png"
                  layout="fixed"
                  width="27px"
                  height="22px"
                  alt=""
                />
              </div>
              <p className="icon-p">Turismo, pacote, intercâmbios ou cruzeiros</p>
            </div>
            <div className="icons-box">
              <div className="icon">
                <img
                  src="static/amp/quemsomos/icons/ic_computer.png"
                  layout="fixed"
                  width="27px"
                  height="22px"
                  alt=""
                />
              </div>
              <p className="icon-p">Informática - hardware e software</p>
            </div>
            <div className="icons-box">
              <div className="icon">
                <img
                  src="static/amp/quemsomos/icons/ic_services_sustainable.png"
                  layout="fixed"
                  width="27px"
                  height="22px"
                  alt=""
                />
              </div>
              <p className="icon-p">
                Produtos sustentáveis - acessibilidade, energias renováveis e processos mais limpos
              </p>
            </div>
          </section>
          <section className="great-box">
            <div className="great-img">
              <img
                src="static/amp/quemsomos/imgs/ic_greatplacetowork.png"
                layout="fixed"
                width="187px"
                height="187px"
                alt="Great Place To Work"
              />
            </div>
            <div className="great-geraltext">
              <p className="great-title">Somos uma das melhores empresas para se trabalhar!</p>
              <p className="great-text">
                Fomos eleitos uma das Top 20 Melhores grandes empresas para trabalhar no Brasil em
                2019, conforme o ranking da consultoria Great Place to Work.
              </p>
            </div>
          </section>
        </Container>
      </section>

      <VejaTambem />
      <Footer />
      <style jsx>{Styles}</style>
    </>
  );
}

export default QuemSomos;
